import Reveal from "@/components/site/Reveal";
import { PlugCharging, Toolbox, Waveform, Wrench, ArrowUpRight } from "@phosphor-icons/react";

const OFFERINGS = [
  {
    n: "01",
    icon: PlugCharging,
    title: "Electrical Appliances",
    body:
      "Supply of certified industrial and commercial electrical appliances — sourced, specified and delivered to spec.",
  },
  {
    n: "02",
    icon: Toolbox,
    title: "Electrical Equipment",
    body:
      "Switchgear, transformers, panels, drives and rig-grade equipment supplied to project schedule and standard.",
  },
  {
    n: "03",
    icon: Waveform,
    title: "Cable Installation Kits",
    body:
      "Complete electrical cable installation kits — armored cable, glands, terminations, tools and consumables.",
  },
  {
    n: "04",
    icon: Wrench,
    title: "Electrical Services",
    body:
      "Installation, testing, commissioning and maintenance of electrical systems — onshore, offshore and shorebase.",
  },
];

export default function Sales() {
  return (
    <section
      id="sales"
      className="relative bg-background border-b border-white/10 py-24 md:py-40"
      data-testid="sales-section"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
          <div className="max-w-3xl">
            <span className="mono-label text-primary">/ Sales &amp; Supply</span>
            <h2 className="mt-6 font-display font-bold uppercase tracking-tight text-4xl md:text-6xl leading-[0.9]">
              Electrical.
              <br />
              Ordered &amp; delivered.
            </h2>
          </div>
          <p className="max-w-sm text-foreground/60 md:pb-2">
            Beyond wireline, we supply the electrical appliances, equipment and cable
            installation kits that keep operations powered — with the field service to
            install, test and maintain them.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
          {OFFERINGS.map((o, i) => {
            const Icon = o.icon;
            return (
              <Reveal
                key={o.n}
                delay={i * 0.06}
                className="border-b border-r border-white/10 p-8 md:p-10 group hover:bg-secondary/40 transition-colors duration-300 min-h-[280px] flex flex-col justify-between"
              >
                <div className="flex items-start justify-between">
                  <Icon
                    size={38}
                    weight="light"
                    className="text-foreground/70 group-hover:text-primary transition-colors duration-300"
                  />
                  <span className="font-mono-tech text-sm text-muted-foreground">
                    {o.n}
                  </span>
                </div>
                <div className="mt-8">
                  <h3 className="font-display font-bold uppercase tracking-tight text-xl md:text-2xl mb-3 flex items-center gap-2">
                    {o.title}
                  </h3>
                  <p className="text-foreground/60 text-sm leading-relaxed">{o.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1} className="mt-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6 border border-white/10 p-8 md:p-10">
          <div>
            <p className="mono-label text-primary">/ Place an order</p>
            <p className="mt-3 font-display font-bold uppercase tracking-tight text-xl md:text-2xl">
              Send your BOM, spec sheet or enquiry to our sales desk.
            </p>
          </div>
          <a
            href="mailto:order@bandcsystem.com"
            className="inline-flex items-center gap-3 bg-primary text-primary-foreground px-7 py-4 mono-label hover:bg-foreground hover:text-background transition-colors duration-200 shrink-0"
            data-testid="sales-cta-email"
          >
            order@bandcsystem.com
            <ArrowUpRight size={18} weight="bold" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
